var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{staticClass:"image-text-content",style:({
    'background-color': _vm.content.background,
    color: _vm.content.text_color
  }),attrs:{"type":"flex","justify":"center","align":"center"}},[_c('vs-col',{staticClass:"text--html",attrs:{"lg":"10","sm":"11","xs":"12","justify":"left"}},[_c('InternalImageContent',{staticClass:"image",attrs:{"src":_vm.content.media,"title":_vm.content.title}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }